import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Form, Input, Modal, Table, theme} from "antd";
import {ColumnsType} from "antd/es/table";
import {ExtensionData, searchExtension} from "../data/ExtensionData";
import {QueryKey, useQueryClient} from "@tanstack/react-query";
import Search from "antd/es/input/Search";
import {useCommonUseMutation, useCommonUseQuery} from "../../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../../Common/util/ProcService";
import {SaveOutlined} from "@ant-design/icons";
import MemoizedTag from "./MemoizedTag";
import MemoizedCheckBox from "./MemoizedCheckBox";

const FileMgrExtension: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();

    const [addPopup, setAddPopup] = useState<boolean>(false);
    const [addExtensionName, setAddExtensionName] = useState<string>("");

    const [extensionStatusState, setExtensionStatusState] = useState<Record<string, boolean>>({});

    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    const queryKey:QueryKey =   [`extensionMgr`];
    let requestParam:searchExtension = {extension:null};
    const queryClient = useQueryClient();

    const { data, isFetching, refetch} = useCommonUseQuery<ExtensionData[]>(
        queryKey,
        () =>procAdminService<ExtensionData[]>("post", `${serviceCode}ADS09`, requestParam));

    const mutateUpdate = useCommonUseMutation<any>(queryKey, queryClient
        , procAdminService);

    function onSearch  (value: string)
    {
        requestParam = {extension:value};
        refetch();
    }

    function updateExtensionStatus(record:ExtensionData, checked:boolean)
    {
        const updateActiveParam:ExtensionData  = {
            extension : record.extension,
            makeThumb : record.makeThumb,
            cnvtSupport : record.cnvtSupport,
            extensionStatus : checked
        }

        const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU01`, requestBody:updateActiveParam }
        mutateUpdate.mutateAsync(updateParam)
            .catch(error => {
                console.error(error);

            }).finally(() => {
        })


    }

    const handleExtensionStatusChange = (record:ExtensionData, checked: boolean) => {
        setExtensionStatusState((prev) => ({
            ...prev,
            [record.extension]: checked,
        }));

        // 서버로 변경된 extensionStatus 업데이트 요청을 보낼 수도 있습니다.
        updateExtensionStatus(record, checked);
    };

    useEffect(() => {
        // 최초 데이터 로딩 시 extensionStatusState 초기화
        if (data) {
            const initialState: Record<string, boolean> = {};
            data.forEach((item) => {
                initialState[item.extension] = item.extensionStatus || false;
            });
            setExtensionStatusState(initialState);
        }
    }, [data]);

    function addExtension()
    {
        setAddPopup(true);
    }

    function closeAddExtension()
    {
        setAddPopup(false);
    }

    function setInputExtension(e:any)
    {
        setAddExtensionName(e.target.value);
    }

    function onAddExtension()
    {
        const updateAddExtension:ExtensionData  = {
            extension : addExtensionName,
            makeThumb : false,
            cnvtSupport : false,
            extensionStatus : true
        }

        updateExtensionStatus(updateAddExtension, true);
        setAddPopup(false);

    }

    const checkExtension = () => {
        if (addExtensionName.length === 0) {
            return Promise.reject(
                `허용할 확장자를 입력하세요`
            );
        }

        return Promise.resolve();
    };




    const columns: ColumnsType<ExtensionData> = [
        {
            title: '허용확장자',
            dataIndex: 'extension',
            key: 'extension',
            render: (text: string) =>
                <MemoizedTag text={text}/>
            ,
        },
        {
            title: '파일변환여부',
            dataIndex: 'cnvtSupport',
            key: 'cnvtSupport',
            render: (text: boolean,record:ExtensionData) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <MemoizedCheckBox checked={record.cnvtSupport || false} />
                </div>
            ,
        },
        {
            title: '썸네일생성여부',
            key: 'makeThumb',
            dataIndex: 'makeThumb',
            render: (text: boolean, record:ExtensionData) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <MemoizedCheckBox checked={record.makeThumb || false} />
                </div>
            ,
        },
        {
            title: '활성화여부',
            dataIndex: 'extensionStatus',
            key: 'extensionStatus',
            render: (text: boolean, record:ExtensionData) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Checkbox
                        checked={extensionStatusState[record.extension]}
                        onChange={(e) => handleExtensionStatusChange(record, e.target.checked)}
                    />
                </div>
            ,
        },
    ];

    return (
        <>
        <nav style={{
            margin:'0px 0px 14px 0px',
            padding:'9px 8px 9px 0px',
            height: '50px',
            display:'flex',
            justifyContent: "space-between",
            alignItems:'center',
            borderRadius: "8px", // 라운드 처리 추가
            border: '1px solid #dadada',
            background: colorBgContainer,
        }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{
                    padding: '9px 5px',
                    display:'flex',
                }}>
                    <Search placeholder="확장자를 검색해보세요." allowClear onSearch={onSearch} style={{ width: 210 }} />
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Button onClick={addExtension} type="primary" size="small">확장자 추가</Button>
            </div>
        </nav>
        <Table columns={columns}
               dataSource={data}
               rowKey="extension"
               loading={isFetching}
        />

            <Modal
                open={addPopup}
                title="허용 확장자 추가"
                onCancel={closeAddExtension}
                footer={[
                    <></>
                ]}
            >
                <Form
                    name="addExtension"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onAddExtension}
                >
                    <Form.Item
                        name="addExtensionName"
                        rules={[
                            {
                                required : true,
                                validator:checkExtension,
                            },
                        ]}
                    >
                        <Input
                            prefix={<SaveOutlined  className="site-form-item-icon" />}
                            placeholder="추가할 확장자 입력"
                            value={addExtensionName}
                            onChange={setInputExtension}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            허용 확장자 추가
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default FileMgrExtension;
